import React from "react";
import { Link } from "react-router-dom";
import "../../../assets/css/patient/Footer.css";
import { FiMail, FiPhone } from "react-icons/fi";

// Quick Links aur Company — edit karke naya link add/remove/change kar sakti hain
// "path": null = page abhi nahi bana, link grey/disabled rahega
const quickLinks = [
  { text: "Home", path: "/" },
  { text: "Blog", path: "/blog" },
];

const companyLinks = [
  { text: "About Us", path: "/about" },
  { text: "Terms & Conditions", path: "/terms" },
  { text: "Privacy Policy", path: "/privacy" },
];

function LinkItem({ link }) {
  return link.path ? (
    <li>
      <Link to={link.path}>{link.text}</Link>
    </li>
  ) : (
    <li className="footer-link-disabled">{link.text}</li>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Brand section */}
        <div className="footer-section footer-brand">
          <div className="footer-logo">
            <span className="logo-icon">●</span>
            <span className="logo-text">
              Smart<span className="logo-accent">Therapy</span>
            </span>
          </div>
          <p className="footer-tagline">AI-POWERED CARE</p>
          <p className="footer-description">
            Empowering individuals with AI-driven speech therapy solutions
            for better communication.
          </p>
        </div>

        {/* Quick Links + Company — side by side, jaise Picks4Tips mein hai */}
        <div className="footer-columns-row">
          <div className="footer-section footer-column">
            <h4 className="footer-heading">Quick Links</h4>
            <ul>
              {quickLinks.map((link) => (
                <LinkItem link={link} key={link.text} />
              ))}
            </ul>
          </div>

          <div className="footer-section footer-column">
            <h4 className="footer-heading">Company</h4>
            <ul>
              {companyLinks.map((link) => (
                <LinkItem link={link} key={link.text} />
              ))}
            </ul>
          </div>
        </div>

        {/* Get In Touch */}
        <div className="footer-section">
          <h4 className="footer-heading">Get In Touch</h4>
          <div className="footer-contact">
            <p>
              <span className="contact-icon">
                <FiPhone />
              </span>
              +92 300 0000000
            </p>
            <p>
              <span className="contact-icon">
                <FiMail />
              </span>
              support@speechtherapy.ai
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} SpeechTherapy. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;